import RemoteEvaluateRequest from "../../../../../mode/remote/RemoteEvaluateRequest"
import { HackleUser } from "../../../../../../model/model"
import WorkspaceEvaluation from "../../../../../../workspace/evaluation/WorkspaceEvaluation"
import InAppMessageLayoutRemoteEvaluateResult from "../../../../../../workspace/evaluation/entity/InAppMessageLayoutRemoteEvaluateResult"
import { InAppMessageEvaluateScope } from "../../../InAppMessageEvaluateScope"
import { InAppMessageLayoutEvaluateRequest } from "../../InAppMessageLayoutEvaluateRequest"

/**
 * A layout request resolved by remote evaluation. Carries the server-resolved layout result as its
 * entity; the remote layout evaluator returns it unchanged (the layout is decided on the server).
 */
export class InAppMessageLayoutRemoteEvaluateRequest
  implements RemoteEvaluateRequest, InAppMessageLayoutEvaluateRequest
{
  readonly record = true

  private constructor(
    readonly workspace: WorkspaceEvaluation,
    readonly user: HackleUser,
    readonly entity: InAppMessageLayoutRemoteEvaluateResult,
    readonly scope: InAppMessageEvaluateScope
  ) {}

  get inAppMessage(): InAppMessageLayoutRemoteEvaluateResult {
    return this.entity
  }

  static of(
    workspace: WorkspaceEvaluation,
    user: HackleUser,
    entity: InAppMessageLayoutRemoteEvaluateResult,
    scope: InAppMessageEvaluateScope
  ): InAppMessageLayoutRemoteEvaluateRequest {
    return new InAppMessageLayoutRemoteEvaluateRequest(workspace, user, entity, scope)
  }

  toString(): string {
    return `InAppMessageLayoutRemoteEvaluateRequest(key=${this.inAppMessage.key})`
  }
}
